import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { VatDt } from 'src/app/account/_components/account-vat/account-vat.component';

@Injectable({
	providedIn: 'root'
})
export class CommonService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	getNazioni() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/countries`);
	}

	// getStatiServizio() {
	// 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/servicestatus`);
	// }

	// getStatiFornServizio() {
	// 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/servicefornstatus`);
	// }

	// getTipologieServizio() {
	// 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/servicetype`);
	// }

	getCodiciIva() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/vatcodes`);
	}
	getIva(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/vatcodes/${id}`);
	}
	deleteIva(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/vatcodes/${id}`);
	}
	upsertIva(data: VatDt) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/commons/vatcodes`, data);
	}
}
